"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("react");function e(r){return r&&r.__esModule?r:{default:r}}var t=e(require("prop-types"));const o={children:t.default.oneOfType([t.default.node,t.default.arrayOf(t.default.node)]).isRequired};class s extends r.Component{constructor(r){super(r),this.state={hasError:!1,error:null,errorInfo:null}}static getDerivedStateFromError(r){return{hasError:!0}}componentDidCatch(r,e){this.setState({hasError:!0,error:r,errorInfo:e}),console.warn(e)}render(){return this.state.hasError?null:this.props.children}}s.propTypes=o,exports.default=s;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/AppManager/ErrorBoundary.js
// module id = 889
// module chunks = 0